import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/polarpumpen-casebg-min.jpg';

export default {
  path: '/cases/polarpumpen',
  color: variables.polarpumpen,
  casebg,
  isWeb: true,
  title: 'Solcellsguiden',
  headline: 'Web application',
  description: 'Consumer transparency in solar power',
  isAndroid: false,
};
